import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion } from "@/components/@common/Accordion/Accordion";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { EXTERNAL_B2B_WEBFLOW_PAGE, EXTERNAL_CAREER_PAGE, EXTERNAL_CHANNEL_TALK, EXTERNAL_COMPANY_INTRODUCE, EXTERNAL_INTRODUCE_LIBRARY, EXTERNAL_PROMOTION_AUTHOR_PAGE, EXTERNAL_PROTECTION_GUIDE, EXTERNAL_PROTECTION_REPORT_CENTER, EXTERNAL_PROTECTION_TRAINING, EXTERNAL_SOLVOOK_BLOG, EXTERNAL_SOLVOOK_GUIDE, INTRODUCE_PAGE, PRIVACY_PAGE, RNUMBER_PAGE, SOLVOOK_STUDENT_BLOG_PAGE, SOLVOOK_WRITE_STUDIO, TERMS_OF_REFUND_PAGE, TERMS_OF_USE_PAGE, UCI_PAGE } from "@/settings/constant";
import { Button, Divider, Icon, Typography } from "@bookips/sds";
import Link from "next/link";
import { useRouter } from "next/router";
// --- 데이터 ---
const categoryLinkList = [
    {
        title: "소개",
        links: [
            {
                title: "회사 소개",
                link: EXTERNAL_COMPANY_INTRODUCE
            },
            {
                title: "서비스 소개",
                link: INTRODUCE_PAGE
            },
            {
                title: "채용",
                link: EXTERNAL_CAREER_PAGE
            }
        ]
    },
    {
        title: "솔루션",
        links: [
            {
                title: "쏠북 마켓",
                link: "/"
            },
            {
                title: "쏠북 엑스퍼트",
                link: SOLVOOK_WRITE_STUDIO
            },
            {
                title: "자료 보관함",
                link: EXTERNAL_INTRODUCE_LIBRARY
            }
        ]
    },
    {
        title: "저작권보호센터",
        links: [
            {
                title: "저작권 침해 신고센터",
                link: EXTERNAL_PROTECTION_REPORT_CENTER
            },
            {
                title: "저작권 안내",
                link: EXTERNAL_PROTECTION_GUIDE
            },
            {
                title: "저작권 교육",
                link: EXTERNAL_PROTECTION_TRAINING
            },
            {
                title: "R인증",
                link: RNUMBER_PAGE
            },
            {
                title: "UCI 코드",
                link: UCI_PAGE
            }
        ]
    },
    {
        title: "문의",
        links: [
            {
                title: "사업 제휴",
                link: EXTERNAL_B2B_WEBFLOW_PAGE
            },
            {
                title: "저자 신청",
                link: EXTERNAL_PROMOTION_AUTHOR_PAGE
            }
        ]
    }
];
const policyLinkList = [
    {
        title: "서비스 이용약관",
        link: TERMS_OF_USE_PAGE
    },
    {
        title: "개인정보처리방침",
        link: PRIVACY_PAGE
    },
    {
        title: "취소/환불 정책",
        link: TERMS_OF_REFUND_PAGE
    }
];
const companyInfoItems = [
    "(주)북아이피스 |",
    "대표 윤미선, 김관백 |",
    "사업자 등록번호 493-88-01679 |",
    "통신판매업 신고 제2021-서울서초-0156호 |",
    "저작권대리중개업 신고 제1496호 |",
    "서울 Hub / R&D Center : 서울시 서초구 반포대로22길 39, 4층 |",
    "충남 Hub : 충남 아산시 배방읍 희망로 46번길 45-11",
    "충남콘텐츠기업지원센터 3층 304호 |",
    "이메일 문의 : support@bookips.com |",
    "전화 문의 : 02-2606-4990 |"
];
const track = (name, url)=>mixpanelEvent("Footer Section Clicked", {
        buttonName: name,
        buttonUrl: url
    });
// --- 재사용 서브 컴포넌트 ---
const FooterLink = (param)=>/*#__PURE__*/ {
    let { title , link  } = param;
    return _jsx(Link, {
        href: link,
        target: link.includes("https") ? "_blank" : "_self",
        onClick: ()=>track(title, link),
        className: "text-secondary typo-body2",
        children: title
    });
};
const PolicyLinks = ()=>/*#__PURE__*/ _jsx("div", {
        className: "flex flex-wrap items-center gap-3",
        children: policyLinkList.map((item, idx)=>/*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3",
                children: [
                    idx > 0 && /*#__PURE__*/ _jsx(Divider, {
                        orientation: "vertical",
                        className: "h-3 self-center"
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        href: item.link,
                        target: item.link.includes("https") ? "_blank" : "_self",
                        onClick: ()=>track(item.title, item.link),
                        className: "text-secondary typo-body2",
                        children: item.title
                    })
                ]
            }, item.title))
    });
const BlogButtons = ()=>{
    const router = useRouter();
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-2",
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "secondary",
                size: "sm",
                onClick: ()=>{
                    track("쏠북 블로그(선생님)", EXTERNAL_SOLVOOK_BLOG);
                    window.open(EXTERNAL_SOLVOOK_BLOG, "_blank", "noreferrer");
                },
                children: "쏠북 블로그(선생님)"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "secondary",
                size: "sm",
                onClick: ()=>{
                    track("쏠북 블로그(학생)", SOLVOOK_STUDENT_BLOG_PAGE);
                    router.push(SOLVOOK_STUDENT_BLOG_PAGE);
                },
                children: "쏠북 블로그(학생)"
            })
        ]
    });
};
const CompanyInfo = ()=>{
    const year = new Date().getFullYear();
    return /*#__PURE__*/ _jsxs("div", {
        className: "typo-caption flex flex-col gap-4",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-secondary flex flex-wrap gap-x-0.5",
                children: companyInfoItems.map((item)=>/*#__PURE__*/ _jsx("span", {
                        children: item
                    }, item))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-muted",
                children: "ⓒ Copyright ".concat(year, ". BookIPs All Rights Reserved.")
            })
        ]
    });
};
// --- 메인 컴포넌트 ---
const Footer = ()=>{
    const router = useRouter();
    return /*#__PURE__*/ _jsx("footer", {
        className: "flex border-t border-gray-100 bg-white px-6 py-10 max-lg:px-8 max-sm:p-5",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto flex w-full max-w-[1200px] flex-col gap-5 sm:gap-7",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-start justify-between max-sm:flex-col max-sm:gap-5",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex w-[273px] shrink-0 flex-col gap-5 max-lg:mr-10 max-sm:w-full",
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "h6",
                                    className: "text-strong",
                                    children: "고객만족센터"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex flex-col gap-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    variant: "stroke",
                                                    color: "secondary",
                                                    className: "text-secondary-main w-[124px]",
                                                    onClick: ()=>{
                                                        track("채널톡 문의", EXTERNAL_CHANNEL_TALK);
                                                        router.push(EXTERNAL_CHANNEL_TALK);
                                                    },
                                                    children: "채널톡 문의"
                                                }),
                                                /*#__PURE__*/ _jsxs(Typography, {
                                                    variant: "caption",
                                                    className: "text-secondary",
                                                    children: [
                                                        "채널톡으로 문의하시면",
                                                        /*#__PURE__*/ _jsx("br", {}),
                                                        "가장 빠른 처리가 가능합니다."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            variant: "stroke",
                                            color: "secondary",
                                            className: "w-fit",
                                            onClick: ()=>{
                                                track("쏠북 이용 가이드", EXTERNAL_SOLVOOK_GUIDE);
                                                router.push(EXTERNAL_SOLVOOK_GUIDE);
                                            },
                                            children: "쏠북 이용 가이드"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "hidden md:flex",
                            children: categoryLinkList.map((category)=>/*#__PURE__*/ _jsxs("div", {
                                    className: "flex w-[200px] flex-col gap-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "subtitle1",
                                            children: category.title
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex flex-col gap-3",
                                            children: category.links.map((item)=>/*#__PURE__*/ _jsx(FooterLink, {
                                                    ...item
                                                }, item.title))
                                        })
                                    ]
                                }, category.title))
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "hidden w-full grid-cols-2 gap-x-4 gap-y-6 sm:grid md:hidden",
                            children: categoryLinkList.map((category)=>/*#__PURE__*/ _jsxs("div", {
                                    className: "flex flex-col gap-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "subtitle1",
                                            children: category.title
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex flex-col gap-3",
                                            children: category.links.map((item)=>/*#__PURE__*/ _jsx(FooterLink, {
                                                    ...item
                                                }, item.title))
                                        })
                                    ]
                                }, category.title))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "w-full border-y border-gray-100 sm:hidden",
                    children: /*#__PURE__*/ _jsx(Accordion.Root, {
                        type: "multiple",
                        children: categoryLinkList.map((category)=>/*#__PURE__*/ _jsxs(Accordion.Item, {
                                value: category.title,
                                border: "bottom",
                                className: "border-gray-100 last:border-b-0",
                                children: [
                                    /*#__PURE__*/ _jsxs(Accordion.Trigger, {
                                        hideIcon: true,
                                        className: "gap-[10px] p-3 hover:bg-transparent",
                                        children: [
                                            /*#__PURE__*/ _jsx(Typography, {
                                                variant: "subtitle1",
                                                className: "flex-1 text-left",
                                                children: category.title
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx(Icon.ArrowDown_2px, {
                                                    className: "accordion-icon size-[18px] text-gray-400 transition-transform duration-200"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Accordion.Content, {
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "flex flex-col gap-3 px-3 pb-3",
                                            children: category.links.map((item)=>/*#__PURE__*/ _jsx(FooterLink, {
                                                    ...item
                                                }, item.title))
                                        })
                                    })
                                ]
                            }, category.title))
                    })
                }),
                /*#__PURE__*/ _jsx("hr", {
                    className: "border-gray-100 max-sm:hidden"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "hidden items-start justify-between sm:flex",
                    children: [
                        /*#__PURE__*/ _jsx(CompanyInfo, {}),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex shrink-0 flex-col items-end justify-between gap-7",
                            children: [
                                /*#__PURE__*/ _jsx(PolicyLinks, {}),
                                /*#__PURE__*/ _jsx(BlogButtons, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col gap-5 sm:hidden",
                    children: [
                        /*#__PURE__*/ _jsx(PolicyLinks, {}),
                        /*#__PURE__*/ _jsx(BlogButtons, {}),
                        /*#__PURE__*/ _jsx(CompanyInfo, {})
                    ]
                })
            ]
        })
    });
};
export default Footer;
